export default __webpack_public_path__ + "static/media/level_translators.d3ae962e.svg";